import script from "./ListProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListProfile.vue?vue&type=script&setup=true&lang=ts"

import "./ListProfile.vue?vue&type=style&index=0&id=bd9faf8a&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd9faf8a"]])

export default __exports__